import CommonUtils from '@/resources/utils/common-utils';

export const checkAuth = (str) => {
  const perMap = new Map()
  if (perMap.has(str)) {
    return perMap.get(str)
  } else {
    const res = CommonUtils.judgePermission(str)
    perMap.set(str, res)
    return res
  }
}

export const getType = (key, key_s, key_p) => {
  let key_secret = key_s || (key + '_secret')
  let key_part = key_p || (key + '_part')

  if (key_part && checkAuth(key_part)) {
    return 'part'
  }
  if (!checkAuth(key) && !checkAuth(key_secret)) {
    return 'default'
  }
  if (checkAuth(key) && !checkAuth(key_secret)) {
    return 'default'
  }
  if (!checkAuth(key) && checkAuth(key_secret)) {
    return 'secret'
  }
  if (checkAuth(key) && checkAuth(key_secret)) {
    return 'default'
  }
}

export const handleApi = (oldApi, type) => {
  const str = oldApi
  const apiInfo = {
    default: str,
    secret: str + '/secret',
    part: str + '/part',
  }
  return apiInfo[type]
}
export function deepClone(target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if(target===null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if(target.constructor===RegExp){
            result = target;
        }else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

export function copyText(text) {
    const copyInput = document.createElement("input");
    copyInput.setAttribute("value", text);
    document.body.appendChild(copyInput);
    copyInput.select();
    document.execCommand("copy");
    document.body.removeChild(copyInput);
}

export const deathProtectionType = [{
  label: '不含身故',
  value: 'not_including'
},{
  label: '身故赔保额',
  value: 'pay_guarantee_quota'
},{
  label: '身故赔保费',
  value: 'pay_premium'
},{
  label: '含身故(不区分赔保额、赔保费）',
  value: 'including'
}]



// WEBPACK FOOTER //
// ./src/utils/common.js